<template>
  <div class="app">
    <div class="content">
      <div class="content-boxs" v-for="(item,index) in list" :key="index" @click="goPage(item)">
        <img :src="item.icon" class="grid-img" />
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  data() {
    return {
      list:[
        {
          title:"网络学院",
          path:"/dqfw/wlxy",
          icon:require("@images/zhdj/bg-wgxy.png")
        },
        {
          title:"读物链接",
          path:"/dqfw/dwlj",
          icon:require("@images/zhdj/bg-dwlj.png")
        },
        {
          title:"先进事迹",
          path:"/dqfw/xjsj-list",
          icon:require("@images/zhdj/bg-xjsj.png")
        },
        {
          title:"党史馆",
          path:"/dqfw/dsg-list",
          icon:require("@images/zhdj/bg-dsg.png")
        },
      ]
    }
  },
  created() {
   
  },
  mounted() {
  },
  methods: {
    goPage(item){
      this.$router.push({
          path: item.path,
        })
    }
  },
}
</script>

<style lang="less" scoped>
.app{
  width: 100%;
  height: 100vh;
  background: #f6f7f9;
}
.content{
  width: 100%;
  padding: 10px 12px;
  box-sizing: border-box;
  &-boxs{
    width: 100%;
    box-sizing: border-box;
    margin: 16px 0px;
    img{
      width: 100%;
    }
  }
}
</style>
